{
    "coordinates": [
        37.789598896238004,
        13.171182106188837
    ],
    "tooltip": "Sicily",
    "title": "Pleistocene Sicily",
    "country": "Italy",
    "period": "Quaternary"
}
